import * as React from 'react';

export default class Loader extends React.Component {
  render() {
    return (
      <button className="button is-loading is-fullwidth is-text is-large" />
    );
  }
}
